function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#A0616A",
  d: "M153.6 332.5c-5.2 0-9.5-4.3-9.5-9.5v-11.3c-3.6 3.8-3.9 9.8-.4 13.9.3.4.6.7 1 1l-5.3 45.9-30.6 2.7h-.2c-4.9.5-8.4 4.9-7.9 9.8s4.9 8.4 9.8 7.9l43-4.6h.1c3.4-1.1 5.6-4.3 5.5-7.9l-1.4-47.9h-4.1z"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.62
}, /*#__PURE__*/React.createElement("path", {
  fill: "#808285",
  d: "M644.5 309.5v152.8c0 8.8-7.2 16-16 16H147.7c-8.8 0-16-7.2-16-16V200.8c0-8.8 7.2-16 16-16h480.8c8.8 0 16 7.2 16 16v9.7H661v-40.1c0-6.8-5.5-12.3-12.3-12.3H127.3c-6.7 0-12.1 5.4-12.1 12.1v308.2c0 9.1 7.4 16.5 16.5 16.5h512.8c9.1 0 16.5-7.4 16.5-16.5V309.5h-16.5z",
  opacity: 0.39
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#808285",
  strokeMiterlimit: 10,
  strokeWidth: 4,
  d: "M665.4 309h-304c-9.1 0-16.5-7.4-16.5-16.5v-65c0-9.1 7.4-16.5 16.5-16.5h304c9.1 0 16.5 7.4 16.5 16.5v65c0 9.1-7.4 16.5-16.5 16.5z",
  opacity: 0.65
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFB8B8",
  d: "M673.6 277.1c1 5.5 6.3 9.1 11.7 8.1.6-.1 1.2-.3 1.7-.5l22.8 27.5 5.4-17.8-22.4-23.4c-2.3-5.1-8.3-7.3-13.4-5-4.3 1.9-6.6 6.5-5.8 11.1z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#2F2E41",
  d: "M505 32.2c7.5 16-8.4 20.5-26.7 29.1s-31.9 17.9-39.4 1.9-13.6-47.7 12.2-59.9c26.7-12.5 46.4 12.9 53.9 28.9z"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 467.7,
  cy: 39.1,
  r: 24.6,
  fill: "#FFB8B8"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#2F2E41",
  d: "M589.4 148c-.9-1.1-1.7-2.2-2.6-3.3-1.1-1.4-2.2-2.7-3.4-4-12.7-14.7-26.3-23.9-41.2-24.9h-.2l-29.7 29-10.1 9.8.2.5 5.4 13.6h95.5c-4.2-7.1-8.8-14-13.9-20.7zM441 49l8.8-4.1-1.2-12.7 5.9 10.5 4.2-2-.7-7.4 3.4 6.1 31.2-14.7c-6.1-13-21.6-18.6-34.6-12.5l-4.5 2.1C440.5 20.5 434.9 36 441 49z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1BA9D",
  d: "M660.8 169.2H115v-8.4c0-9.1 7.4-16.5 16.6-16.5h512.7c9.1 0 16.5 7.4 16.6 16.5v8.4h-.1z"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 145.1,
  cy: 156.8,
  r: 4.3,
  fill: "#FFF"
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 161.3,
  cy: 156.8,
  r: 4.3,
  fill: "#FFF"
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  cx: 177.6,
  cy: 156.8,
  r: 4.3,
  fill: "#FFF"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fill: "#9C9162",
  d: "M825.4 451.7c-.9-.1-1.8-.5-2.4-1.2l-6.3-5.8c-1.4-1.3-1.8-3.3-1.1-5.1l12.5-29.7-1.8-58.7c1.1-7.9 8.4-13.5 16.3-12.4 7.9 1.1 13.5 8.4 12.4 16.3l3 36.9c.9 11.2-2.3 22.4-8.9 31.4l-19.6 26.4c-.8 1-1.9 1.7-3.2 1.8-.2.1-.6.1-.9.1z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#808285",
  strokeMiterlimit: 10,
  strokeWidth: 4,
  d: "M403.32 421.6h-43c-5.2 0-9.5-4.3-9.5-9.5v-43c0-5.2 4.3-9.5 9.5-9.5h43c5.2 0 9.5 4.3 9.5 9.5v43c0 5.2-4.2 9.5-9.5 9.5z",
  opacity: 0.65
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  fill: "#808285",
  d: "m396.72 378.1-7.2-5.8c-.6-.5-1.2-.7-1.9-.7h-18.8c-1.7 0-3 1.3-3 3v32c0 1.7 1.3 3 3 3h26c1.7 0 3-1.4 3-3v-26.2c0-.9-.4-1.7-1.1-2.3zm-6.9 19.5h-16c-.6 0-1-.4-1-1s.4-1 1-1h16c.6 0 1 .4 1 1s-.4 1-1 1zm0-6h-16c-.6 0-1-.4-1-1s.4-1 1-1h16c.6 0 1 .4 1 1s-.4 1-1 1zm0-6h-16c-.6 0-1-.4-1-1s.4-1 1-1h16c.6 0 1 .4 1 1s-.4 1-1 1z",
  opacity: 0.65
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#808285",
  strokeMiterlimit: 10,
  strokeWidth: 4,
  d: "M505.74 421.6h-43c-5.2 0-9.5-4.3-9.5-9.5v-43c0-5.2 4.3-9.5 9.5-9.5h43c5.2 0 9.5 4.3 9.5 9.5v43c0 5.2-4.2 9.5-9.5 9.5z",
  opacity: 0.65
});

var _ref17 = /*#__PURE__*/React.createElement("g", {
  fill: "#808285",
  opacity: 0.65
}, /*#__PURE__*/React.createElement("path", {
  d: "M486.69 393.68c-.86.58-1.58.72-2.45.72s-1.58-.29-2.3-.72l-19.28-12.03v20.52c0 .86.58 1.44 1.44 1.44h40.29c.86 0 1.44-.58 1.44-1.44v-20.44l-19.14 11.95z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M483.52 391.24c.43.29 1.01.29 1.58 0l20.54-12.81c-.23-.43-.66-.72-1.25-.72H464.1c-.55 0-.96.26-1.21.65l20.63 12.88z"
}));

var _ref18 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#808285",
  strokeMiterlimit: 10,
  strokeWidth: 4,
  d: "M300.9 421.6h-43c-5.2 0-9.5-4.3-9.5-9.5v-43c0-5.2 4.3-9.5 9.5-9.5h43c5.2 0 9.5 4.3 9.5 9.5v43c0 5.2-4.2 9.5-9.5 9.5z",
  opacity: 0.65
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  fill: "#808285",
  d: "M256.5 377.65v24.42c0 .91.61 1.53 1.53 1.53h3.85c0-.51.13-1.03.43-1.53l6.71-11.6c.15-.46.61-.76 1.06-1.06 1.38-.91 3.21-.46 4.12 1.06l3.51 5.95 5.95-10.37c.15-.46.61-.76 1.06-1.06 1.38-.91 3.21-.46 4.12 1.06l9.31 16.02c.3.46.46.91.46 1.53h2.14c.91 0 1.53-.61 1.53-1.53v-24.42c0-.91-.61-1.53-1.53-1.53h-42.73c-.9 0-1.52.6-1.52 1.53zm3.06 4.57a3.06 3.06 0 1 1 3.06 3.06c-1.7 0-3.06-1.37-3.06-3.06z",
  opacity: 0.65
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFB8B8",
  d: "m768.8 648.2-12.2-.1-5.9-47.2h18.1v47.3z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  fill: "#2F2E41",
  d: "M772 660h-39.5v-.5c0-8.5 6.9-15.4 15.4-15.4H772V660z"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFB8B8",
  d: "m818.8 648.2-12.2-.1-5.9-47.2h18.1v47.3z"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  fill: "#2F2E41",
  d: "M822 660h-39.5v-.5c0-8.5 6.9-15.4 15.4-15.4H822V660z"
});

var _ref24 = /*#__PURE__*/React.createElement("circle", {
  cx: 815.1,
  cy: 290.5,
  r: 24.6,
  fill: "#FFB8B8"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  fill: "#2F2E41",
  d: "M758.74 453.8h-.04l-.03.47.07-.47zm-.1.9L747.9 613.1c-.1 2.2 1.4 4.2 3.6 4.7l14.5 3h.1c2.4.5 4.8-1.2 5.2-3.6L789 520c0-.2.2-.4.5-.4s.5.1.5.4l10.5 100.4c.2 1.8 1.5 3.3 3.2 3.8l11.4 3.5c.5.1.9.1 1.4.1 2.4 0 4.4-1.8 4.5-4.2l10.13-166.64-72.49-2.26z"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  fill: "#B8AC8C",
  d: "m858 392-3-36.9c1.09-7.86-4.44-15.12-12.27-16.28a37.5 37.5 0 0 0-20.23-14.32c-1.6-.5-3.1-.8-4.7-1.1-11.28-1.81-22.2 1.61-30.32 8.46-1.04-1.26-2.3-2.37-3.78-3.26l-54.8-21.3-22.5-23.1c-1.3-1.4-3.4-1.8-5.1-1l-7.8 3.5c-.8.4-1.5 1-2 1.8-.1.3-.3.6-.3 1.1-.4 1.2-.2 2.5.4 3.6l16.7 28.3c5.7 9.7 14.7 17 25.4 20.5l35.2 11.6c1.74 1.03 3.6 1.66 5.49 1.91L758.6 454.7l73.9 2.3 2.79-15 13.81-18.6c6.6-9 9.8-20.2 8.9-31.4z"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "m835 375.7-1 32-18.4 32L831 404l4-28.3z",
  opacity: 0.1
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  fill: "#2F2E41",
  d: "M812.3 295.1c-3.2.4-6.2-1.6-7-4.7-.8-3.5-3.5-6.3-7-7.3-4.5-1-10 1.1-13.3-2.3-1.4-1.6-2-3.8-1.6-5.8.6-3.3 3-5.8 5.6-7.8 5.4-4.2 12-6.7 18.9-7.1 3.5-.1 7.1.1 10.6.5 3.7.2 7.3.9 10.9 2 8.2 3.1 14.2 10.1 16 18.7 1.6 8.5-.6 17.4-6.1 24.1-3.2 4-7.4 7.2-12.2 9.3-1.1.5-2.4.6-3.6.2-3-1.2-2.5-4.8-1.1-7.3 1.4-2.6 3.7-5.1 2.5-8.3-.6-1.5-1.7-2.7-3.1-3.4-3-1.5-6.3-1.2-9.5-.8z"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  fill: "#D5D7D8",
  d: "M628.4 293h-230c-9.1 0-16.5-7.4-16.5-16.5v-34c0-9.1 7.4-16.5 16.5-16.5h230c9.1 0 16.5 7.4 16.5 16.5v34c0 9.1-7.4 16.5-16.5 16.5z",
  opacity: 0.48
});

var _ref30 = /*#__PURE__*/React.createElement("circle", {
  cx: 447.9,
  cy: 254.9,
  r: 19.7,
  fill: "#DA2128"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  fill: "#3F3D56",
  d: "m614.1 291-27.9-23.4-27.4-23c-1.5-1.3-3.7-1.2-5.2 0l-27.3 23.1-6.7 5.6-10-8.4-30.5-25.6c-1.5-1.3-3.7-1.2-5.2 0L443.5 265l-30.9 26.1c-.4.4-.5 1-.1 1.4.2.2.5.4.8.4l63.4-.1h20.1l-.2.2 59.8-.1 57.1-.1c.6 0 1-.4 1-1 0-.3-.1-.6-.4-.8z"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "M875.3 661.5h-192c-.6 0-1-.4-1-1s.4-1 1-1h192c.6 0 1 .4 1 1s-.5 1-1 1z",
  opacity: 0.46
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFB8B8",
  d: "M604.1 131.9c-1.6-2.6-4.2-4.5-7.2-5.1-.5-.1-1.1-.2-1.7-.2L519 58.5c-1.5-1.5-3.5-2.5-5.6-2.7-.4 0-.8-.1-1.3 0-5 .2-8.9 4.5-8.6 9.5.1 2.3 1.1 4.4 2.7 6l29.2 25.4 47.9 41.8c0 .8.2 1.6.4 2.3 1.2 4.5 5 7.9 9.7 8.4 2.1.2 4.2-.1 6.1-1 1.5-.7 2.8-1.7 3.9-3 .1-.1.2-.2.3-.4 2.6-3.8 2.8-8.9.4-12.9zm-130.4 65.7-.7-28.9-.6-24-.4-16.7-.8-32.7c-.5-5-4.9-8.6-9.8-8.2-2.3.2-4.4 1.3-5.9 2.9-.3.3-.5.6-.8 1-1.2 1.8-1.8 3.9-1.6 6.1l1.8 47.7.9 24 1.1 30.5c-.3.4-.6.9-.9 1.4-1.4 2.7-1.7 5.9-.7 8.8 2 5.9 8.4 9.1 14.3 7.1.4-.1.8-.3 1.2-.5 5.6-2.7 8.1-9.4 5.4-15-.5-1.3-1.4-2.5-2.5-3.5z"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "m542.3 115.8-7.1-19.1-11.4-31c-1.7-4.6-5.3-8.1-10-9.7-.2-.1-.4-.1-.5-.2-4.5-1.4-9.3-.7-13.2 1.8L461.6 82c-7.3 4.6-9.7 14.3-5.3 21.8 4.8 8.3 10.1 16.4 15.7 24.2 4.5 6.1 12.9 6.8 14.3 16.8h28.4l28.8-25.8-1.2-3.2z"
});

var _ref35 = /*#__PURE__*/React.createElement("circle", {
  cx: 101.2,
  cy: 326.7,
  r: 23.2,
  fill: "#A0616A"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  fill: "#A0616A",
  d: "M139.3 649.2h11.6l5.5-44.6h-17.1v44.6z"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  fill: "#2F2E41",
  d: "M136.4 645.4h22.8c8 0 14.5 6.5 14.5 14.5v.5h-37.3v-15z"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  fill: "#A0616A",
  d: "m24.4 633.2 9.9 5.9 27.6-35.5-14.7-8.8-22.8 38.4z"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  fill: "#2F2E41",
  d: "m23.8 628.4 19.6 11.7c6.9 4.1 9.1 13 5 19.9l-.2.4-32-19.1 7.6-12.9zm129.8 5h-13c-2.2 0-4-1.6-4.2-3.8l-13.1-122.7c-.1-.8-.8-1.3-1.6-1.3-.5.1-.9.4-1.1.8L97 558.6l-41.7 68c-1.1 1.8-3.4 2.5-5.3 1.7L33.3 621c-2.1-.9-3.1-3.5-2.2-5.6.1-.2.2-.3.2-.5l38.3-64.2 11.8-54.1c-3.7-23.5 12.2-58.3 12.3-58.7l.1-.2 43.7-17.1.2.3c17.2 56.5 27.7 117.3 20 208.6 0 2.2-1.9 3.9-4.1 3.9z"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  fill: "#2F2E41",
  d: "m92.2 443.5-.2-.5c-.1-.2-9.8-20.7-17.3-42.6-2.9-8.6-2.1-17.9 2.2-25.9 4.4-8 11.9-13.8 20.8-16 15.7-3.8 31.9 4.6 37.9 19.6 5.9 14.8 4 30.7 2.3 43.2v.2l-.2.1-45.5 21.9zM129.3 313.6H92.5v-16c8.1-3.2 16-5.9 20.8 0 8.8 0 16 7.1 16 16z"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  fill: "#2F2E41",
  d: "M90.4 294.7c-22 0-28.2 27.6-28.2 43.1 0 8.7 3.9 11.8 10.1 12.8l2.2-11.6 5.1 12.1c1.7 0 3.6 0 5.4-.1l1.7-3.6 3.9 3.5c15.4 0 27.9 2.3 27.9-13.2.1-15.4-5.3-43-28.1-43z"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "M193 661.5H1c-.6 0-1-.4-1-1s.4-1 1-1h192c.6 0 1 .4 1 1s-.4 1-1 1z",
  opacity: 0.46
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#808285",
  strokeMiterlimit: 10,
  strokeWidth: 4,
  d: "M196.62 332.5h-43c-5.2 0-9.5-4.3-9.5-9.5v-43c0-5.2 4.3-9.5 9.5-9.5h43c5.2 0 9.5 4.3 9.5 9.5v43c0 5.2-4.2 9.5-9.5 9.5z",
  opacity: 0.65
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  fill: "#808285",
  d: "M189.08 315h-28c-1.7 0-3-1.3-3-3v-21c0-1.7 1.3-3 3-3h7.9c1 0 2 .5 2.6 1.4l2.2 3.6h15.4c1.7 0 3 1.3 3 3v16c-.1 1.6-1.4 3-3.1 3z",
  opacity: 0.65
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFB8B8",
  d: "m823.7 457.3 2.98-5.77c-.13.02-.25.06-.38.07-.2.1-.6.1-.9.1-.9-.1-1.8-.5-2.4-1.2l-6.3-5.8a4.48 4.48 0 0 1-1.36-2.52l-6.44 15.12c-3.8 4.1-3.5 10.5.6 14.3 3.3 3.2 8.5 3.6 12.4 1 4.6-3.1 5.9-9.3 2.9-13.9-.3-.5-.7-1-1.1-1.4z"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  fill: "#A0616A",
  d: "M188.2 325.6c.1.3.3.5.4.8 2.3 5.2 0 11.4-5.3 13.7-.4.2-.7.3-1.1.4-.3.1-.7.2-1 .2l-19.1 49.4c-1.3 3.3-4.6 5.4-8.2 5.1h-.1l-41.4-12.5c-4.7-1.4-7.4-6.4-6-11.1s6.4-7.4 11.1-6h.2L147 375l22.7-40.2c-.2-.4-.4-.8-.5-1.3-1.7-5.5 1.3-11.3 6.8-13 4.7-1.3 9.8.7 12.2 5.1z"
});

function SvgBuildingWebsites(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 876.3 661.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingWebsites);
export default __webpack_public_path__ + "static/media/building_websites.79c5bf1f0365668c99651edb2284fa01.svg";
export { ForwardRef as ReactComponent };